// @flow

import { graphql } from 'react-relay';
import { ROOT_ID } from 'relay-runtime';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation AddReturnOrderMutation($input: AddReturnOrderInput!) {
    addReturnOrder(input: $input) {
      returnOrderEdge {
        node {
          id
          returnNumber
          status
          returnType
          reason
          authorizedDate
          receivedDate
          notes
          customerNotes
          order {
            id
            orderNumber
          }
          customer {
            id
            name
          }
          shipment {
            id
            shipmentNumber
          }
          lines(first: 1000) {
            edges {
              node {
                id
                quantity
                receivedQuantity
                condition
                disposition
                restocked
                notes
                item {
                  id
                  name
                  itemNumber
                }
              }
            }
          }
          updatedAt
          createdAt
        }
      }
    }
  }
`;

export default {
  commit: (options: Object) => {
    return createRelayMutation(mutation, {
      ...options,
      configs: [
        {
          type: 'RANGE_ADD',
          parentID: ROOT_ID,
          connectionInfo: [
            {
              key: 'PaginatedReturnsContainer_returnOrders',
              rangeBehavior: 'prepend',
            },
          ],
          edgeName: 'returnOrderEdge',
        },
      ],
    });
  },
};
